const DocsPage = () => {
  return (
    <div className="info-page">
      <div className="info-page__header">
        <h1 className="info-page__title">Documentation</h1>
        <p className="info-page__subtitle">Technical reference for the milligram.tv protocol</p>
      </div>

      <div className="info-page__sections">
        <section className="info-page__section">
          <h3>Tokens</h3>
          <div className="info-page__table">
            <div className="info-page__table-row info-page__table-row--header">
              <span>Token</span>
              <span>Description</span>
              <span>Standard</span>
            </div>
            <div className="info-page__table-row">
              <span><strong>PAXG</strong></span>
              <span>Pax Gold &mdash; 1:1 backed by physical gold</span>
              <span>ERC-20</span>
            </div>
            <div className="info-page__table-row">
              <span><strong>MG</strong></span>
              <span>Milligram &mdash; 1 mg of gold (1/31,103.5 PAXG)</span>
              <span>ERC-20</span>
            </div>
            <div className="info-page__table-row">
              <span><strong>MGTV</strong></span>
              <span>Milligram TV &mdash; governance &amp; fee discount token</span>
              <span>ERC-20</span>
            </div>
            <div className="info-page__table-row">
              <span><strong>USDT</strong></span>
              <span>Tether &mdash; USD stablecoin</span>
              <span>ERC-20</span>
            </div>
          </div>
        </section>

        <section className="info-page__section">
          <h3>Gold Vault</h3>
          <p>
            The Gold Vault smart contract allows users to mint MG by locking PAXG and
            redeem PAXG by burning MG.
          </p>
          <div className="info-page__detail">
            <div className="info-page__detail-row">
              <span>Conversion Rate</span>
              <strong>1 PAXG = 31,103.5 MG</strong>
            </div>
            <div className="info-page__detail-row">
              <span>Standard Fee</span>
              <strong>3.69%</strong>
            </div>
            <div className="info-page__detail-row">
              <span>MGTV Discount Fee</span>
              <strong>0.369% + 0.1% MGTV burn</strong>
            </div>
          </div>
        </section>

        <section className="info-page__section">
          <h3>Exchange</h3>
          <p>
            The decentralized exchange uses an on-chain order book model. Users deposit tokens
            into the exchange contract and create limit orders. Orders are matched and filled
            on-chain when a counterparty accepts the price.
          </p>
          <div className="info-page__detail">
            <div className="info-page__detail-row">
              <span>Order Type</span>
              <strong>Limit Orders</strong>
            </div>
            <div className="info-page__detail-row">
              <span>Settlement</span>
              <strong>On-chain atomic swap</strong>
            </div>
            <div className="info-page__detail-row">
              <span>Custody</span>
              <strong>Non-custodial (self-custody)</strong>
            </div>
          </div>
        </section>

        <section className="info-page__section">
          <h3>Swap</h3>
          <p>
            The Swap feature provides instant token exchanges between ETH, USDT, and PAXG
            via the Uniswap V2 Router. Swaps execute directly on-chain through Uniswap&apos;s
            decentralized liquidity pools &mdash; no intermediaries.
          </p>
          <div className="info-page__detail">
            <div className="info-page__detail-row">
              <span>Protocol</span>
              <strong>Uniswap V2</strong>
            </div>
            <div className="info-page__detail-row">
              <span>Supported Tokens</span>
              <strong>ETH, USDT, PAXG</strong>
            </div>
            <div className="info-page__detail-row">
              <span>Default Slippage</span>
              <strong>0.5%</strong>
            </div>
            <div className="info-page__detail-row">
              <span>Availability</span>
              <strong>Ethereum Mainnet only</strong>
            </div>
          </div>
        </section>

        <section className="info-page__section">
          <h3>Supported Networks</h3>
          <div className="info-page__detail">
            <div className="info-page__detail-row">
              <span>Sepolia Testnet</span>
              <strong>Chain ID 11155111</strong>
            </div>
            <div className="info-page__detail-row">
              <span>Ethereum Mainnet</span>
              <strong>Chain ID 1</strong>
            </div>
          </div>
        </section>
      </div>
    </div>
  )
}

export default DocsPage
